<nav class="main">
    @for (item of menuItems; track item.label) {
        @if (item.children) {
            <app-menu-header
                [label]="item.label | translate"
                [collapsed]="isCollapsed(item.label)"
                [class.mt-auto]="item.pinToBottom"
                (toggleCollapse)="toggleHeader(item.label)"
            />
            @if (!isCollapsed(item.label)) {
                @for (child of item.children; track child.label) {
                    @if (child.routerLink) {
                        <app-menu-item [label]="child.label | translate" [icon]="child.icon" [routerLink]="child.routerLink" (click)="picked.emit()" />
                    }
                }
            }
        } @else if (item.routerLink) {
            <app-menu-item [label]="item.label | translate" [icon]="item.icon" [routerLink]="item.routerLink" (click)="picked.emit()" />
        }
    }
</nav>
